import { __extends } from "tslib";
import React from 'react';
import classnames from 'classnames';
import TextRenderer from '../TextRenderer';
import PollAnswer from '../DaEditorWrapper/Viewer/PollAnswer';
import DeviationDumbView from '../DeviationViews/Dumbo';
import DeviationLink from '../Duperbrowse/DeviationLink';
import s from './PollOption.scss';
var PollOption = /** @class */ (function (_super) {
    __extends(PollOption, _super);
    function PollOption() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            var _a = _this.props, onClick = _a.onClick, answerId = _a.answer.answerId, canVote = _a.canVote;
            if (!answerId || !canVote) {
                return;
            }
            onClick(answerId);
        };
        return _this;
    }
    PollOption.prototype.render = function () {
        var _a = this.props, answer = _a.answer, className = _a.className, canVote = _a.canVote;
        return (React.createElement("div", { className: classnames(s['root'], canVote && s['can-vote'], className) },
            answer.deviationId &&
                (answer.image ? (
                // Deviation exists and is active, we can render the poll option thumb as normal
                React.createElement("div", { className: s['image-block'] },
                    React.createElement(DeviationLink, { deviation: answer.image, target: "_blank" },
                        React.createElement(DeviationDumbView, { className: s['image-block-link'], deviation: answer.image, width: 80, height: 80 })))) : (
                // Deviation exists but is inactive/deleted
                // Render an Unknown thumb (a "null" deviation) instead
                React.createElement("div", { className: s['image-block'] },
                    React.createElement(DeviationDumbView, { deviation: {}, width: 80, height: 80 })))),
            React.createElement("div", { className: s['text-block'], onClick: this.onClick },
                answer.textContent && (React.createElement(TextRenderer, { htmlExcerptLegacy: true, isPollWithHtmlExcerpt: true, className: s['answer-text'], textContent: answer.textContent, reactViewer: PollAnswer, viewerKey: answer.answerId })),
                React.createElement("div", { className: s['progress-bar'] },
                    React.createElement("div", { className: s['progress-bar__value'], style: { width: answer.percentvotes + "%" } })),
                React.createElement("div", { className: s['percent-votes'] },
                    answer.percentvotes,
                    "%"))));
    };
    return PollOption;
}(React.Component));
export default PollOption;
//# sourceMappingURL=PollOption.js.map